const SalaryDetails = ({ t }) => {
  return (
    <div className="space-y-4">
      <section className="flex items-center gap-2 p-4 border bg-sideBar rounded-xl border-primary">
        <img
          src="/assets/team1.jpg"
          alt="هشام المدير"
          className="object-cover rounded-full size-[50px]"
        />
        <div>
          <p className="text-xl font-semibold text-primary">خالد علي </p>
          <p>مدير تقنية المعلومات</p>
        </div>
      </section>
      <section className="p-4 space-y-3 rounded-lg bg-sideBar">
        <h3 className="font-bold">{t("financialAccountDetails")}</h3>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p>{t("baseSalary")}:</p>
            <p>12,000 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p>{t("housingAllowance")}:</p>
            <p>12,000 JD</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p>{t("transportationAllowance")}:</p>
            <p className="text-xl font-semibold">12,000 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p>{t("bonuses")}:</p>
            <p className="text-[#11A849] text-xl font-semibold">1,000 JD</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p>{t("transportationAllowance")}:</p>
            <p className="text-xl font-semibold">1,000 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p>{t("bonuses")}:</p>
            <p className="text-[#11A849] text-xl font-semibold">1,000 JD</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p>{t("taxes")}:</p>
            <p className="text-[#C42E27] text-xl font-semibold">-200 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p>{t("advance")}:</p>
            <p className="text-[#C42E27] text-xl font-semibold">-500 JD</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p>{t("deductions")}:</p>
            <p className="text-[#C42E27] text-xl font-semibold">0 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p>{t("insurance")}:</p>
            <p className="text-[#C42E27] text-xl font-semibold">-100 JD</p>
          </div>
        </div>
        <hr className="my-4 border-dashed" />
        <div className="w-full space-y-2 capitalize">
          <p>{t("total")}</p>
          <p className="text-xl font-semibold">14,200 JD</p>
        </div>
      </section>
    </div>
  );
};

export default SalaryDetails;
